export function formatMooney(mooney?: number): string {
  return mooney
    ? mooney.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      })
    : "R$ 0,00";
}
